import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, Clock3Icon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { IMAGES } from '../data/landing';
import { useOfferCountdown } from '../utils/useOfferCountdown';
const lineas = [{
  label: 'Saga completa de 4 Tomos (250 recetas)',
  valor: '$39.990'
}, {
  label: 'Bonus 1 — Tabla de Tiempos y Temp.',
  valor: '$14.900'
}, {
  label: 'Bonus 2 — Menú "Mes Resuelto"',
  valor: '$17.900'
}, {
  label: 'Bonus 3 — Carnes Baratas que saben a Lomo',
  valor: '$15.900'
}, {
  label: 'Bonus 4 — 50 Recetas Fit e Hiper-Proteicas',
  valor: '$18.900'
}, {
  label: 'Bonus 5 — Guía de Limpieza y Mantenimiento',
  valor: '$13.900'
}];
export function OfferSection() {
  const countdown = useOfferCountdown();
  return <section id="oferta-principal" className="w-full bg-[#0d1f36] py-10 text-white sm:py-16" data-id="element-126" data-mp="2t59ldip79spk">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-127" data-mp="2y4cqf356jyxj">
        <div className="text-center" data-id="element-128" data-mp="2y4w7khn0ajai">
          <img src={IMAGES.mockupPrincipal} alt="MegaPack Air Fryer Argentina con 4 tomos y 5 bonos incluidos" className="mx-auto mb-5 w-full max-w-md drop-shadow-2xl" data-id="element-129" data-mp="12nib9frye1qu" />
          <h2 className="text-2xl font-black leading-tight sm:text-3xl lg:text-4xl" data-id="element-130" data-mp="xvh2w4xwov63">Mirá todo lo que te llevás hoy</h2>
          <p className="mt-3 text-base text-slate-300" data-id="element-131" data-mp="svckg9dftqd8">Un solo pago. Acceso de por vida. Sin suscripciones ni letra chica.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-7 rounded-3xl border border-white/10 bg-[#132c4d] p-5 sm:p-8" data-id="element-132" data-mp="1lmmicizxplfv">
          <ul className="space-y-3" data-id="element-133" data-mp="17mv7us8mmn6m">
            {lineas.map(linea => <li key={linea.label} className="flex items-center justify-between gap-3 border-b border-white/10 pb-3 text-sm sm:text-base" data-id="element-134" data-mp="17oxwb7u4s898">
                <span className="flex items-center gap-2 text-slate-100" data-id="element-135" data-mp="3scklj1xlg2xq"><CheckIcon className="h-4 w-4 shrink-0 text-orange-400" data-id="element-136" data-mp="3sf6v1741osil" />{linea.label}</span>
                <span className="shrink-0 text-slate-400 line-through" data-id="element-137" data-mp="3trwqernj0x3n">{linea.valor}</span>
              </li>)}
          </ul>

          <p className="mt-5 text-right text-sm text-slate-300" data-id="element-138" data-mp="3ktul3zwrfiak">Valor total del MegaPack + bonos: <span className="font-bold text-white line-through" data-id="element-139" data-mp="3oumvwxla5v8y">$121.490</span></p>

          <div className="mt-4 overflow-hidden rounded-2xl border border-yellow-400/30 bg-[#09182b] text-center" data-id="element-140" data-mp="3owr9k78ze8mf">
            <div className="bg-yellow-400 px-4 py-2 text-xs font-black uppercase tracking-widest text-[#0d1f36]" data-id="element-141" data-mp="3ftygpzk5houh">Oferta especial de hoy · 63% OFF</div>
            <div className="p-6" data-id="element-142" data-mp="316wynv882u4t">
              <div className="mx-auto flex w-fit items-center gap-2 rounded-full border border-red-400/50 bg-red-500/10 px-4 py-2 text-xs font-black uppercase tracking-wide text-red-100" data-id="element-143" data-mp="364evin8ytiwg">
                <Clock3Icon className="h-4 w-4 text-yellow-300" data-id="element-144" data-mp="2s701t6boioyo" /> Termina en <span aria-live="polite" className="rounded bg-red-600 px-2 py-0.5 tabular-nums text-white" data-id="element-145" data-mp="2x2fevw1v4gu1">{countdown}</span>
              </div>
              <p className="mt-5 text-sm font-bold uppercase tracking-widest text-slate-400" data-id="element-146" data-mp="2djrvaitbf7t1">Antes</p>
              <p className="mt-1 text-2xl font-black text-slate-500 line-through sm:text-3xl" data-id="element-147" data-mp="2min3g0fx6ryz">$39.990</p>
              <p className="mt-4 text-sm font-bold uppercase tracking-widest text-slate-400" data-id="element-148" data-mp="2ih1mo409ltji">Hoy te llevás todo por</p>
              <p className="mt-1 text-5xl font-black text-yellow-400 sm:text-6xl" data-id="element-149" data-mp="2wg9oz5rq5hrx">$14.900</p>
              <p className="mt-4 inline-flex rounded-full bg-orange-600 px-4 py-2 text-sm font-black text-white" data-id="element-150" data-mp="2ri82sbz052c8">RECIBÍS $81.500 EN BONOS GRATIS HOY</p>
              <p className="mt-3 text-sm text-slate-400" data-id="element-151" data-mp="365t4c1g8ati1">Pago único · Equivale a un solo delivery que te llega frío.</p>
            </div>
          </div>

          <div className="mt-6" data-id="element-152" data-mp="3f6r8cjqo310m"><CtaButton checkout showPaymentSeal data-id="element-153" data-mp="3f82fmtjbmqwh" /></div>
        </motion.div>
      </div>
    </section>;
}